// i18next
import i18n from "../../../config/translation/i18n";
// API
import { get } from "../../../services/api";
// Ducks
import { hideSpinner, showSpinner } from "../../../services/spinner.ducks";

export const getPaymentHistory = () => async (dispatch) => {
  const { language } = i18n;
  try {
    dispatch(showSpinner());
    const { data } = await dispatch(get(`/paymentHistory?localeCode=${language}`));
    dispatch(hideSpinner());

    return data;
  } catch (error) {
    return [];
  }
};
